import { useState } from 'react'
import type { Company } from '../types'

type CompanySelectorProps = {
  companies: Company[]
  selectedCompany: string
  onSelectCompany: (companyId: string) => void
  onCreateCompany: (name: string) => void
  onDeleteCompany: () => void
}

export function CompanySelector({
  companies,
  selectedCompany,
  onSelectCompany,
  onCreateCompany,
  onDeleteCompany,
}: CompanySelectorProps) {
  const [newCompanyName, setNewCompanyName] = useState('')

  function handleCreate() {
    if (!newCompanyName.trim()) return
    onCreateCompany(newCompanyName.trim())
    setNewCompanyName('')
  }

  return (
    <>
      <div className="card p-6 mb-6">
        <h2 className="text-lg font-semibold text-theme-primary mb-4">Create New Company</h2>
        <div className="flex space-x-2">
          <input
            type="text"
            value={newCompanyName}
            onChange={(e) => setNewCompanyName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
            placeholder="Company name"
            className="input flex-1"
          />
          <button onClick={handleCreate} className="btn-primary">
            Create
          </button>
        </div>
      </div>

      <div className="card p-6 mb-6">
        <h2 className="text-lg font-semibold text-theme-primary mb-4">Manage Company</h2>
        <select
          value={selectedCompany}
          onChange={(e) => onSelectCompany(e.target.value)}
          className="input"
        >
          <option value="">Select a company...</option>
          {companies.map((company) => (
            <option key={company.id} value={company.id}>
              {company.name}
            </option>
          ))}
        </select>
      </div>

      {selectedCompany && (
        <div className="card p-6 mb-6">
          <h2 className="text-lg font-semibold text-red-500 mb-4">Danger Zone</h2>
          <button onClick={onDeleteCompany} className="btn-danger">
            Delete Company
          </button>
          <p className="text-xs text-theme-muted mt-2">
            This will permanently delete all company data including websites, scraped content, and uploaded documents.
          </p>
        </div>
      )}
    </>
  )
}
